module.exports = __webpack_public_path__ + "img/fashion_07.bf0ed002.jpg";